import { RegularExpressions } from "../../../Helpers/RegularExpression";
import { ValFormReg } from "../../../Validators/ValForms";
import { GetKey } from "../../../Helpers/GetKey";

export const ValidarDatosFactura = (
  state,
  factura,
  nota,
  folio,
  financiera,
  tiene_factura,
  tiene_nota,
  registro
) => {
  const serie_fiscal = ValFormReg(
    "Serie Fiscal",
    state.serie_fiscal,
    RegularExpressions.TextAndNumber
  );
  const folio_fiscal = ValFormReg(
    "Folio Fiscal",
    state.folio_fiscal,
    RegularExpressions.TextAndNumber
  );
  const documento = ValFormReg(
    "Documento",
    state.documento,
    RegularExpressions.TextOnlyNumber
  );
  const idequip = ValFormReg(
    "ID EQUIP",
    state.idequip,
    RegularExpressions.TextOnlyNumber
  );
  var comentarios = ValFormReg(
    "Comentarios",
    state.comentarios,
    RegularExpressions.TextSpecialCharacter
  );
  var isValid = true;
  var mensaje = "";
  if (serie_fiscal.isValid === false) {
    isValid = false;
    mensaje += serie_fiscal.mensaje;
  }
  if (folio_fiscal.isValid === false) {
    isValid = false;
    mensaje += folio_fiscal.mensaje;
  }
  if (documento.isValid === false) {
    isValid = false;
    mensaje += documento.mensaje;
  }
  if (idequip.isValid === false) {
    isValid = false;
    mensaje += idequip.mensaje;
  }
  if (comentarios.isValid === false) {
    state.comentarios = "EQUIPO FACTURADO";
  }
  if (
    state.sucursal === undefined ||
    state.sucursal === null ||
    state.sucursal === ""
  ) {
    isValid = false;
    mensaje += `No se tiene registrada una sucursal para el usuario <br>`;
  }
  if (tiene_factura === false) {
    if (
      factura === undefined ||
      factura === null ||
      factura === "" ||
      factura.documento === undefined ||
      factura.documento === null ||
      factura.documento === ""
    ) {
      isValid = false;
      mensaje += "Falta agregar la Factura del equipo <br>";
    }
  }
  // if (financiera === "JDF" && tiene_nota === false) {
  //   if (
  //     nota === undefined ||
  //     nota === null ||
  //     nota === "" ||
  //     nota.documento === undefined ||
  //     nota.documento === null ||
  //     nota.documento === ""
  //   ) {
  //     isValid = false;
  //     mensaje += "Falta agregar la Nota de Abono  <br>";
  //   }
  // }
  if (isValid === false) {
    return { isValid, mensaje };
  } else {
    return {
      isValid,
      post: {
        folio,
        registro,
        factura: factura.documento,
        nota_abono: nota.documento,
        comentarios: state.comentarios,
        estatus: "A",
        idequip: state.idequip,
        idsucursal: GetKey(state.sucursal),
        serie_fiscal: state.serie_fiscal,
        folio_fiscal: state.folio_fiscal,
        documento: state.documento,
        documentos: [],
      },
    };
  }
};
